import { PERMISSIONS } from '@app/constants/permissions';
import { useAppSelector } from '@app/hooks/index';
import { userHasPermission } from '@app/util/permissions';
import { useAuth } from '@auth/hooks';
import { selectFilter } from '@dashboard/slices/filters';
import { selectProjects } from '@dashboard/slices/projects';
import { useMemo } from 'react';

export const useCanViewIdentificationStats = () => {
  const { user } = useAuth();
  const hasPermissionToViewIdentificationStats = userHasPermission(
    user,
    PERMISSIONS.VIEW.identificationStats,
  );
  const projects = useAppSelector(selectProjects);
  const { projects: selectedProjectsUuids } = useAppSelector(selectFilter);

  return useMemo(() => {
    if (!hasPermissionToViewIdentificationStats) {
      return false;
    }

    return projects.some(
      (project) =>
        project.has_neurodevelopment_identification_stats &&
        selectedProjectsUuids.includes(project.uuid),
    );
  }, [hasPermissionToViewIdentificationStats, projects, selectedProjectsUuids]);
};
